import * as React from 'react';
import { Column } from 'elc-grid';
import { classes } from '../../utils/Classes';
import { MPP_SHADE_NAME } from '../../constants/DataTestIdAttributes';
import { SHADE_INFO_POSITION_TYPE } from '../../constants/ShadeInfoPositionType';
import { IShadeInfo, IShadeDescription } from '../../interfaces/IShadePicker';
import { ColorTitle } from './ProductShadePickerStyles';

const ShadeDescription = ({ position, selectedShade }: IShadeDescription) => {
    const shadeDescriptionClassNames = classes(`shade-description-${position}`);

    return (
        <div className={shadeDescriptionClassNames}>
            {selectedShade.description && `[${selectedShade.description}]`}
        </div>
    );
};

export const ShadeInfo = (props: IShadeInfo) => {
    const { shadeDescriptionPosition, shadeNamePosition, selectedShade, separator } = props;

    const { ABOVE, BELOW, INLINE, NONE } = SHADE_INFO_POSITION_TYPE;
    const shadeDescriptionAboveName = shadeDescriptionPosition === ABOVE;
    const shadeDescriptionBelowName = shadeDescriptionPosition === BELOW;
    const shadeDescriptionInline = shadeDescriptionPosition === INLINE;
    const displayShadeInfo = shadeNamePosition !== NONE;
    const shadePickerTitleClassNames = classes('product-shade-picker-title');

    return (
        <Column>
            <ColorTitle
                color={selectedShade.hexVal || selectedShade.colors[0]}
                data-test-id={MPP_SHADE_NAME}
                className={shadePickerTitleClassNames}
            >
                {shadeDescriptionAboveName && (
                    <ShadeDescription selectedShade={selectedShade} position={ABOVE} />
                )}
                {displayShadeInfo && selectedShade.name}
                {shadeDescriptionInline && (
                    <>
                        {separator}
                        {selectedShade.description && `[${selectedShade.description}]`}
                    </>
                )}
                {shadeDescriptionBelowName && (
                    <ShadeDescription selectedShade={selectedShade} position={BELOW} />
                )}
            </ColorTitle>
        </Column>
    );
};
